type OpenHoursProps = {
  is24Hour: boolean;
  isOpen: boolean;
  openingStatus: string;
  title: string;
  contact?: string;
};

const OpenHours = ({
  is24Hour,
  isOpen,
  openingStatus,
  title,
  contact,
}: OpenHoursProps) => {
  const renderOpen24Hour = () => {
    return (
      <li className="open-hours__container open-hours__container--open ch-display--flex ch-justify-content--between">
        <div>
          <span className="ch-fw--500 ch-display--block">{title}</span>
          {contact && (
            <a
              className="ch-text-decoration--none"
              href={`tel:${contact.replace(/\s/g, '')}`}
            >
              {contact}
            </a>
          )}
        </div>
        <div className="ch-text--right ch-color--grey-6">
          <div className="open-hours__label--open">Open 24/7</div>
        </div>
      </li>
    );
  };

  const renderRegularHours = () => {
    return (
      <li
        className={`open-hours__container open-hours__container--${
          isOpen ? 'open' : 'closed'
        } ch-display--flex ch-justify-content--between`}
      >
        <div>
          <span className="ch-fw--500 ch-display--block">{title}</span>
          {contact && (
            <a
              className="ch-text-decoration--none"
              href={`tel:${contact.replace(/\s/g, '')}`}
            >
              {contact}
            </a>
          )}
        </div>
        <div className="ch-text--right ch-color--grey-6">
          <div className={isOpen ? 'open-hours__label--open' : ''}>
            {isOpen ? 'Open now' : 'Closed'}
          </div>
          <div>{openingStatus}</div>
        </div>
      </li>
    );
  };

  return is24Hour ? renderOpen24Hour() : renderRegularHours();
};

export default OpenHours;
